import type { Voucher } from "@/types/admin-portal/vouchers";

export type OwnerChangeWarning = "move" | "release";

// The saved owner, not the form's prefill: a failed link reopens the form on the pick
// (pendingOwner) while the bonuses still sit with the saved owner.
export function ownerChangeWarning(
	voucher:
		| Pick<Voucher, "program" | "therapist" | "usedCount">
		| null
		| undefined,
	values: { bonusRo: boolean; therapistId: string },
): OwnerChangeWarning | null {
	const currentOwnerId =
		voucher?.program === "BONUS_RO" ? voucher.therapist?.id : undefined;
	if (!currentOwnerId || !voucher || voucher.usedCount <= 0) return null;

	const nextOwnerId = values.bonusRo ? values.therapistId : "";
	if (!nextOwnerId) return "release";
	return nextOwnerId.toLowerCase() === currentOwnerId.toLowerCase()
		? null
		: "move";
}
